export class ArrayEnumerable extends Array {
}
